module.exports = __webpack_public_path__ + "static/media/19.a2fb1e64.jpg";